module.exports = __webpack_public_path__ + "static/img/topButton2.bef3fd5c.png";